/**
 * 数字缩写展示：1234 -> 1.2K, 19700 -> 19.7K, 1200000 -> 1.2M
 */
export function formatCount(count?: number | string): string {
  const num = Number(count) || 0
  if (num >= 1_000_000)
    return `${trimZero(num / 1_000_000)}M`
  if (num >= 1000)
    return `${trimZero(num / 1000)}K`
  return String(num)
}

function trimZero(n: number): string {
  return n.toFixed(1).replace(/\.0$/, '')
}
